export  const NavigationConstant = {
    NAVIGATION_SAGA: "NAVIGATION_SAGA",
    NAVIGATION_REQUEST: "NAVIGATION_REQUEST",
    NAVIGATION_RESPONSE: "NAVIGATION_RESPONSE",
    NAVIGATION_API: "/get-all-navigation",
  
   
  };
  